import {IconProps} from "../../types/IconProps";

export const ChatIcon = ({ width = 800, color = '#000'}: IconProps) => {
    return (
        <svg width={`${width}px`} height={`${width}px`} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="3" cy="3" r="3" transform="matrix(-1 0 0 1 22 2)" stroke={color} strokeWidth="1.5"/>
            <path d="M14 2.20004C13.3538 2.06886 12.6849 2 12 2C6.47715 2 2 6.47715 2 12C2 13.5997 2.37562 15.1116 3.04346 16.4525C3.22094 16.8088 3.28001 17.2161 3.17712 17.6006L2.58151 19.8267C2.32295 20.793 3.20701 21.677 4.17335 21.4185L6.39939 20.8229C6.78393 20.72 7.19121 20.7791 7.54753 20.9565C8.88837 21.6244 10.4003 22 12 22C17.5228 22 22 17.5228 22 12C22 11.3151 21.9311 10.6462 21.8 10" stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
    )
}